import moment from 'moment';
import * as constAction from 'root/actionConstants';

export const clear = payload => ({
  type: constAction.GRUPOS_SOLICITUDES_CLEAR,
  payload,
});

export const setState = payload => ({
  type: constAction.GRUPOS_SOLICITUDES_SET_STATE,
  payload,
});

export const getGruposSolicitudes = (skip = 0) => ({
  type: constAction.GRUPOS_SOLICITUDES_GET,
  payload: { skip },
  epic: {
    url: 'solicitudes/getAll',
    method: 'GET',
  },
});

export const getCantidadGruposSolicitudes = () => ({
  type: constAction.GRUPOS_SOLICITUDES_CUANTOS_HAY,
  epic: {
    url: 'solicitudes/cuantasHay',
    method: 'GET',
  },
});

export const seleccionar = (solicitudId, seleccionada) => ({
  type: constAction.GRUPOS_SOLICITUDES_SELECCIONAR,
  payload: { solicitudId, seleccionada },
});

export const seleccionarTodas = seleccionar => ({
  type: constAction.GRUPOS_SOLICITUDES_SELECCIONAR_TODAS,
  payload: { seleccionar },
});

export const aceptarSolicitudes = (solicitudesId, aceptada) => ({
  type: constAction.GRUPOS_SOLICITUDES_ACEPTAR_SELECCIONADAS,
  payload: { solicitudesId, aceptada },
  epic: {
    url: 'solicitudes/solucionar',
    method: 'POST',
  },
});



// WEBPACK FOOTER //
// src/modules/gruposSolicitudes/action.js